import { useDataProviderContext } from "../../DataProvider";
import OverviewComponent from "./OverviewComponent";

function OverviewContainer() {
  const { magnetDetailsState, publishMagnet, reloadMagnetDetails, brandId, loading, error } = useDataProviderContext();
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    return <div>Oops, something went wrong. Please try again later.</div>;
  }
  return (
    <OverviewComponent
      brandId={brandId}
      magnet={magnetDetailsState}
      publishMagnet={publishMagnet}
      reloadMagnetDetails={reloadMagnetDetails}
    />
  );
}

export default OverviewContainer;
